import type { CSSProperties } from "react";

/** Shared grid layout for all 3 levels of the OKR tree table */
export const TREE_ROW_COLS: CSSProperties = {
    gridTemplateColumns: "1fr 120px 220px 160px 40px",
};

/** Droppable ids — one DragDropContext per page, levels separated by `type`. */
export const OBJECTIVE_DROPPABLE = "objectives";
export const KR_DROPPABLE_PREFIX = "kr-";
export const krDroppableId = (objectivePid: string) => `${KR_DROPPABLE_PREFIX}${objectivePid}`;

/** Base row classes shared by Objective, KR and PPP rows */
export const TREE_ROW_BASE =
    "group relative grid gap-3 px-6 min-h-[52px] items-center border-b border-border/40 transition-colors";
